import type { MapMarker } from "../map.type";
import type { Location } from "react-router";

export const getMarkerLink = (marker: MapMarker, location: Location) => {
  if (!marker.to) return undefined;
  if (location.pathname.includes(marker.to)) return undefined;
  return marker.to;
};
